/**
 * Microsoft icon component using official Microsoft brand colors - shadcn/ui compatible
 */

import * as React from 'react';
import { cn } from '../../lib/utils';

interface MicrosoftIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function MicrosoftIcon({ className, ...props }: MicrosoftIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-5 w-5', className)}
      {...props}
    >
      <path d="M1 1h10v10H1z" fill="#F25022" />
      <path d="M13 1h10v10H13z" fill="#7FBA00" />
      <path d="M1 13h10v10H1z" fill="#00A4EF" />
      <path d="M13 13h10v10H13z" fill="#FFB900" />
    </svg>
  );
}
